<template>
  <v-autocomplete
    label="Counter"
    item-text="id"
    item-value="id"
    :items="countersLight"
    v-model="selectedCounter"
  >
  </v-autocomplete>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    value: String,
  },
  data() {
    return {
      selectedCounter: this.value,
    };
  },
  watch: {
    value(val) {
      this.selectedCounter = val;
    },
    selectedCounter(val) {
      this.$emit('input', val);
    },
  },
  computed: {
    ...mapGetters(['countersLight']),
  },
  created() {
    this.getCountersLight();
  },
  methods: {
    ...mapActions(['getCountersLight']),
  },
};
</script>
